export default "__VITE_ASSET__ATLUls4I__"